/**
 * 路由守卫校验
 */
import Login from "@/pages/onboard/Login";
import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
function RouterWaiter({ routerConfig }) {
  const navigate = useNavigate();
  useEffect(() => {
    const isToken = localStorage.getItem("USER_TOKEN_RETAIL_AI");
    const pathname = window.location.pathname;

    const config = routerConfig.filter(
      (x) => pathname === x.path || pathname === x.path + "/",
    );
    if (!isToken && config[0]?.needLogin !== false) {
      navigate("/");
      return <Route path="/" element={<Login />} />;
    }
  }, []);
  return (
    <Routes>
      {routerConfig.map((item) => {
        return (
          <Route key={item.path} path={item.path} element={item.comment} />
        );
      })}
    </Routes>
  );
}

export default RouterWaiter;
